import { render, staticRenderFns } from "./KnGroupSchoolCycle.vue?vue&type=template&id=3865372e"
import script from "./KnGroupSchoolCycle.js?vue&type=script&lang=js&external"
export * from "./KnGroupSchoolCycle.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports